import axios from 'axios'


export default function fetch(options) {
    // 使用xhr
    return new Promise((resolve, reject) => {

        const instance = axios.create();

        // http request 拦截器
        instance.interceptors.request.use(
            config => {
                return config;
            },
            err => {
                reject(err);
            });

        // http response  拦截器
        instance.interceptors.response.use(function (response) {
            // 对响应数据做点什么
            return response;
        }, function (err) {
            return Promise.reject(err);
        });

        //请求处理
        instance(options)
            .then((res) => {
                resolve(res);
            })
            .catch((error) => {
                throw Error(error);
            })
    })
}